export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

/**
 * The theme actually applied to the DOM.
 *
 * `Theme` is the user's preference (may be `SYSTEM`). `ResolvedTheme` is
 * the concrete value rendered after consulting `prefers-color-scheme` —
 * always `LIGHT` or `DARK`, never `SYSTEM`.
 */
export type ResolvedTheme = Theme.LIGHT | Theme.DARK;
